module.exports = __webpack_public_path__ + "img/icon-white-54.cba08297.svg";